module.exports = __webpack_public_path__ + "media/images/radish-96e8094d2d98299f2199b0a4b5197f11.jpg";